import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useAuth } from "./AuthProvider";
import environment from "../env";

const AccessibilityContext = createContext();
export const useAccessibility = () => useContext(AccessibilityContext);

const AccessibilityProvider = ({ children }) => {
    const { accessToken } = useAuth() || {};
    const apiUrl = environment.CUSTOMER_PORTAL_API;
    const apiKey = environment.CUSTOMER_PORTAL_API_KEY;

    const defaultHeaders = useMemo(() => {
        const headers = {
            "x-api-key": apiKey,
            "organisation": environment.CLIENT_NAME,
            "Content-Type": "application/json",
        };
        if (accessToken) {
            headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return headers;
    }, [apiKey, accessToken]);

    const postAccessibility = async (request) => {
        console.log("Sending accessibility request:", request);
        try {
            const response = await fetch(`${apiUrl}/accessibility`, {
                method: "POST",
                headers: defaultHeaders,
                body: JSON.stringify(request),
            });
            return response.ok ? response.json() : Promise.reject(await response.json());
        } catch (error) {
            console.error("Error posting accessibility:", error);
        }
    };

    const postNote = async (request) => {
        console.log("Sending note request:", request);
        try {
            const response = await fetch(`${apiUrl}/note`, {
                method: "POST",
                headers: defaultHeaders,
                body: JSON.stringify(request),
            });
            return response.ok ? response.json() : Promise.reject(await response.json());
        } catch (error) {
            console.error("Error posting note:", error);
        }
    }

    const getAccessibility = async () => {
        console.log("Getting accessibility settings...");
        try {
            const response = await fetch(`${apiUrl}/accessibility`, {
                method: "GET",
                headers: defaultHeaders,
            });
            return response.ok ? response.json() : Promise.reject(await response.json());
        } catch (error) {
            console.error("Error fetching accessibility settings:", error);
        }
    };

    const contextValue = useMemo(() => ({ postAccessibility, getAccessibility, postNote }), [postAccessibility, getAccessibility, postNote]);

    return (
        <AccessibilityContext.Provider value={contextValue}>
            {children}
        </AccessibilityContext.Provider>
    );
};

AccessibilityProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AccessibilityProvider;
